export const schema = {
  id: 'caravan-boat-lpg-safety-record',
  name: 'Caravan & Marine Boat LPG Gas Safety Record (BS EN ISO 10239 & BS EN 1949)',
  description: 'Statutory LPG Safety Record for Touring Caravans, Motorhomes, Inland Waterway Boats & Marine Vessels (Boat Safety Scheme BSS)',
  category: 'Gas Safety',
  sections: [
    {
      id: 'engineerDetails',
      title: '1. Gas Safe Registered Engineer Details',
      fields: [
        { id: 'engineerName', label: 'Gas Safe Engineer Name', type: 'text', required: true },
        { id: 'gasSafeNumber', label: 'Gas Safe Registration Number', type: 'text', required: true },
        { id: 'boatOrCaravanAccreditation', label: 'Accreditation (LPG Caravans / Boats - BSS / CCLP1)', type: 'text', required: true },
        { id: 'companyName', label: 'Company Name', type: 'text', required: true },
        { id: 'companyAddress', label: 'Company Address', type: 'textarea', required: true },
        { id: 'telephone', label: 'Telephone Number', type: 'tel', required: true }
      ]
    },
    {
      id: 'craftOrCaravanDetails',
      title: '2. Vessel / Caravan Identification & Owner Details',
      fields: [
        { id: 'craftType', label: 'Craft / Vehicle Type', type: 'select', options: ['Narrowboat / Inland Waterway (BSS)', 'Cruiser / Yacht (Marine BS EN ISO 10239)', 'Touring Caravan (BS EN 1949)', 'Motorhome / Campervan', 'Static Caravan / Holiday Home'], required: true },
        { id: 'craftNameOrReg', label: 'Vessel Name / BSS Index No. / Caravan CRiS No.', type: 'text', required: true },
        { id: 'makeAndModel', label: 'Make & Model Description', type: 'text', required: true },
        { id: 'mooringOrSiteLocation', label: 'Mooring Marina / Caravan Site Location', type: 'text', required: true },
        { id: 'ownerName', label: 'Owner / Duty Holder Name', type: 'text', required: true },
        { id: 'ownerAddress', label: 'Owner Address', type: 'textarea', required: true },
        { id: 'inspectionDate', label: 'Inspection Date', type: 'date', required: true }
      ]
    },
    {
      id: 'lpgLockerAndSupply',
      title: '3. Marine / Caravan LPG Locker & Supply Integrity',
      fields: [
        { id: 'gasLockerVapourTight', label: 'Locker Vapour-Tight to Interior & Opening Outwards?', type: 'select', options: ['Yes - Fully Vapour-Tight', 'No - Defects Noted'], required: true },
        { id: 'overboardDrainClear', label: 'Locker Overboard Drain Clear & Min 19mm Bore (Above Waterline)?', type: 'select', options: ['Pass - Clear Overboard', 'Failed / Obstructed', 'N/A - Caravan Low Vent'], required: true },
        { id: 'cylinderSecuredUpright', label: 'Cylinders Restrained Securely in Upright Position?', type: 'select', options: ['Yes', 'No'], required: true },
        { id: 'marineRegulatorType', label: 'Regulator Specification (Marine Grade Annex M / 30mbar EN 12864)', type: 'text', required: true },
        { id: 'flexibleHoseConditionAndDate', label: 'Flexible Hose Condition & Expiration Date Verified (BS 3212/BS ISO 2928)?', type: 'select', options: ['Pass - In Date', 'Expired - Replaced', 'Failed - Perished'], required: true },
        { id: 'bubbleLeakDetectorFitted', label: 'Bubble Leak Detector Fitted & Operational in Locker?', type: 'select', options: ['Yes - No Bubbles Observed (Pass)', 'Yes - Leak Indicated', 'No Bubble Tester Fitted'], required: true }
      ]
    },
    {
      id: 'pipeworkAndTightness',
      title: '4. Pipework, Isolation & Tightness Testing',
      fields: [
        { id: 'pipeworkMaterial', label: 'Gas Pipework Material', type: 'select', options: ['Seamless Copper (Sheathed / Clipped)', 'Stainless Steel (Marine Grade)', 'Continuous Length with Accessible Joints'], required: true },
        { id: 'emergencyShutOffAccessible', label: 'Individual Appliance & Main Isolation Valves Accessible?', type: 'select', options: ['Yes - Labelled', 'No'], required: true },
        { id: 'operatingPressureMbar', label: 'Working Pressure (30mbar Propane/Butane or 37mbar)', type: 'number', required: true },
        { id: 'tightnessTestResult', label: 'Gas Tightness Test (2-Minute Gauge Test)', type: 'select', options: ['Pass (0.0 mbar drop)', 'Failed (Leak Detected)'], required: true },
        { id: 'tightnessDropRecordedMbar', label: 'Pressure Drop Recorded (mbar)', type: 'number', required: true },
        { id: 'coAlarmFitted', label: 'Carbon Monoxide (CO) Alarm Fitted (BS EN 50291-2 Marine/Caravan)?', type: 'select', options: ['Yes - In Date & Tested', 'No - Warning Note Issued'], required: true }
      ]
    },
    {
      id: 'appliances',
      title: '5. Marine / Caravan LPG Appliances Checklist',
      fields: [
        { id: 'cookerMakeModel', label: 'Cooker / Hob (Make & Model)', type: 'text', required: true },
        { id: 'cookerFfd', label: 'Cooker 100% Flame Failure Protection (FFD on all burners)?', type: 'select', options: ['Pass (All Burners FFD Protected)', 'Failed (Non-FFD Burner Present)', 'N/A'], required: true },
        { id: 'waterHeaterMakeModel', label: 'Water Heater / Boiler (e.g. Truma Ultrastore, Morco, Alde)', type: 'text' },
        { id: 'waterHeaterFlueAndFfd', label: 'Water Heater Room-Sealed Flue & FFD Checked?', type: 'select', options: ['Pass - Room Sealed Flue OK', 'Failed', 'N/A'] },
        { id: 'spaceHeaterMakeModel', label: 'Space Heater / Furnace (e.g. Propex, Truma VarioHeat, Webasto LPG)', type: 'text' },
        { id: 'spaceHeaterFlueAndFfd', label: 'Space Heater Flue & Safety Cut-off Verified?', type: 'select', options: ['Pass', 'Failed', 'N/A'] },
        { id: 'refrigeratorMakeModel', label: 'LPG Absorption 3-Way Refrigerator (if fitted)', type: 'text' },
        { id: 'refrigeratorRoomSealed', label: 'Refrigerator Room-Sealed to Living Accommodation?', type: 'select', options: ['Pass - Sealed to Living Area', 'Failed / Open to Cabin', 'N/A'] }
      ]
    },
    {
      id: 'verdictAndSignatures',
      title: '6. Safety Assessment & Sign-Off',
      fields: [
        { id: 'overallAssessment', label: 'Overall LPG Installation Safety Assessment', type: 'select', options: ['SATISFACTORY - SAFE FOR USE (BSS / EN ISO 10239 PASS)', 'AT RISK (AR) - ADVISORY ISSUED', 'IMMEDIATELY DANGEROUS (ID) - ISOLATED / DISCONNECTED'], required: true },
        { id: 'remedialWorkNotes', label: 'Engineer Remedial Notes & Recommendations', type: 'textarea' },
        { id: 'nextInspectionDueDate', label: 'Next Periodic Gas Safety Inspection Due', type: 'date', required: true },
        { id: 'engineerSignature', label: 'Gas Safe Marine/Caravan Engineer Signature', type: 'signature', required: true },
        { id: 'ownerSignature', label: 'Vessel / Caravan Owner Signature', type: 'signature', required: true }
      ]
    }
  ]
};

export default schema;
